import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { Menu, X, Moon, Sun } from "lucide-react";
import SquaayLogo from "../../../utils/svgs/SquaayLogo";
import { ThemeContext } from "../../../context/ThemeContext";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");
  const { theme, toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    const isIOS =
      /iphone|ipad|ipod/.test(ua) ||
      (ua.includes("mac") && "ontouchend" in document);

    if (isIOS) {
      setDownloadLink("https://apps.apple.com/app/squaay/id6740501959");
    } else {
      setDownloadLink(
        "https://play.google.com/store/apps/details?id=com.squaay.android"
      );
    }
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const navLinks = [
    // { label: "About Us", path: "/about" },
    // { label: "Become a Rider", path: "/riders" },
    // { label: "Become a Vendor", path: "/vendor" },
    { label: "Contact Us", path: "/help-center" },
    {label: "Blog", path: "/blog"},
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}${theme}`}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <SquaayLogo
              height={36}
              primaryColor={theme === "dark" ? "#ffffff" : "#2B2320"}
            />
          </Link>

          <div className="navbar-links">
            {navLinks.map((link, idx) => (
              <Link key={idx} to={link.path} className="nav-link">
                {link.label}
              </Link>
            ))}
          </div>

          <div className="navbar-cta">
            <a
              href={downloadLink}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              Download App
            </a>

            <button
              className="theme-toggle-btn"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              title={
                theme === "dark"
                  ? "Switch to Light Mode"
                  : "Switch to Dark Mode"
              }
            >
              {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
            </button>
          </div>

          <button
            className="mobile-menu-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-content">
            {navLinks.map((link, idx) => (
              <Link
                key={idx}
                to={link.path}
                className="mobile-nav-link"
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            ))}
            <div className="mobile-navbar-cta">
              <a
                href={downloadLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-download-btn"
                onClick={closeMenu}
              >
                Download App
              </a>
              <button
                className="mobile-theme-toggle"
                onClick={() => {
                  toggleTheme();
                  closeMenu();
                }}
                aria-label="Toggle theme"
              >
                {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
